import { AssetTransfer } from './asset-transfer';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { ProductCategory } from 'src/app/assabil-kernel/models/entities/control-tables/product-category-entity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';



export class AssetCall extends BaseEntity {

  assetCallCode     : string;
  partner           : Partner         = new Partner();
  productCategory   : ProductCategory = new ProductCategory();
  callReasonCode    : string;
  role              : Role            = new Role();
  person            : Person          = new Person();
  theDate           : Date;	
  progressLevel     : number;
  plannedDate       : Date;
  approvalRole      : Role            = new Role();
  approvalPerson    : Person          = new Person();
  approvalDate      : Date;

  requestRejectionReasonCode : string;
   notes            : string;

  assetTransfer     : AssetTransfer;

  constructor() {
    super();

  }
}

	
